module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"party_dates":["Meet&Greet","PamperPlay","BabyBrunch"]}}')
  delete Component.options._Ctor
}
